<template>
  <div
    :class="[customClass]"
  >
    <div class="full loading-mask border-radius-5" />
    <div
      ref="talkjsContainer"
      class="absolute-full"
    />
    <template v-if="currentConversationId">
      <div
        class="chatbox-back-btn"
        @click="backToMessageList"
      >
        <i class="isif isif-arrow-left" />
      </div>
      <div class="chatbox-favorite-btn">
        <i-favorite
          :item="{ objectId: currentCompanyObjectIdInConversation }"
          category="user"
          small
          animate
        />
      </div>
      <div
        class="chatbox-close-btn"
        @click="closeChatBox"
      >
        <i
          class="isif isif-close"
        />
      </div>
    </template>
    <template v-else>
      <message-list />
    </template>
    <template v-if="activeFAQ">
      <Chatbot :data="FAQ" />
    </template>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import InstantMessagingChat from '@/plugins/talkjs'
import Chatbot from './Chatbot'
import MessageList from './MessageList'
import { Loading } from 'element-ui'
import IFavorite from '@/components/IFavorite'
import webStorage from '../../store/webStorage/helper'

const ChatInstance = InstantMessagingChat.getOrInitInstance()

export default {
  name: 'ChatboxContainer',

  components: {
    Chatbot,
    IFavorite,
    MessageList
  },

  props: {
    customClass: {
      type: String,
      required: false,
      default: ''
    }
  },

  data () {
    return {
    }
  },
  computed: {
    ...mapGetters({
      user: 'user',
      isFavoritesEnabled: 'favorites/enabled',
      isLogin: 'auth/isLogin',
      authUser: 'auth/user',
      property: 'property',
      currentBuilding: 'currentBuilding',
      currentConversationId: 'currentConversationId',
      conversations: 'conversations'
    }),

    FAQ () {
      return this.user.instantMessagingAttribute ? this.user.instantMessagingAttribute.FAQ || {} : {}
    },

    activeFAQ () {
      return Boolean(Object.keys(this.FAQ).length > 0 && this.currentConversationId)
    },

    currentCompanyObjectIdInConversation () {
      return this.currentConversationId ? this.currentConversationId.split('__')[0] : null
    }
  },

  watch: {
    currentConversationId () {
      const loadingInstance = Loading.service({ target: '.loading-mask', fullscreen: false, customClass: 'border-radius-5' })
      setTimeout(() => {
        loadingInstance.close()
      }, 800)
    },

    show (val, oldVal) {
      if (!oldVal && val) {
        this.setCurrentConversationId(this.currentConversationId)
      }
    }
  },

  async mounted () {
    window.addEventListener('message', this.buttonEventHandler)
    const currentUser = this.isLogin ? this.authUser : JSON.parse(webStorage.getItem(process.env.MIXPANEL_STORAGE_KEY + this.currentBuilding.objectId))
    await ChatInstance.init(
      currentUser,
      this.user, {
        buildingId: this.currentBuilding.objectId,
        buildingName: this.currentBuilding.name
      }, {
        onMessageEventCallback: this.onMessageEventHandler
      },
      this.$refs.talkjsContainer
    )
    this.setCurrentConversationId(ChatInstance.getCurrentCaseConversation().id)
    this.createChatboxHtmlPanel()
  },

  beforeDestroy () {
    window.removeEventListener('message', this.buttonEventHandler)
  },

  methods: {
    ...mapActions([
      'toggleChatbox',
      'toggleFAQ',
      'setCurrentConversationId',
      'onMessageEventHandler'
    ]),
    buttonEventHandler (event) {
      if (event.origin !== location.origin) return
      switch (event.data) {
        case 'chatbox-calendar':
          this.calendarBtnHandler()
          this.closeChatBox()
          break
        case 'chatbox-reservation':
          this.reservationBtnHandler()
          this.closeChatBox()
          break
        case 'chatbox-faq':
          this.toggleFAQ(true)
          break
        default:
          break
      }
    },

    calendarBtnHandler () {
      const calendarBtn = document.querySelector('#IStagingCalendarBtn')
      if (calendarBtn) calendarBtn.click()
    },

    reservationBtnHandler () {
      const guideBtn = document.querySelector('#IStagingTourGuideBtn')
      if (guideBtn) guideBtn.click()
    },

    closeChatBox () {
      this.toggleChatbox(false)
    },

    backToMessageList () {
      this.setCurrentConversationId(null)
      ChatInstance.switchConversation(null)
    },

    createChatboxHtmlPanel () {
      if ([this.currentBuilding.calendar, this.currentBuilding.tourRingBtn, this.activeFAQ].some(featureActive => featureActive)) {
        ChatInstance.createHtmlPanel({
          url: `/static/instant-messaging/chatbox-buttons-panel.html?calendar=${this.currentBuilding.calendar}&reservation=${this.currentBuilding.tourRingBtn}&faq=${this.activeFAQ}`,
          height: 60
        })
      }
    }
  }
}
</script>

<style lang="stylus">
@import '~css/addon/main'
@import '~css/common/extends'

.chatbox-back-btn {
  position: absolute
  left: 0
  top: 1%
  width: 36px
  height: 48px
  border-radius: 10px 0 0 10px
  display: flex
  justify-content: center
  align-items: center
  cursor: pointer
}

.chatbox-favorite-btn {
  position: absolute
  right: 49px
  top: 1%
  width: 36px
  height: 48px
  display: flex
  justify-content: center
  align-items: center
}

.chatbox-close-btn{
  font-size: 24px;
  height: 48px
  position: absolute
  right: 6px
  top: 1%
  display: flex
  justify-content: center
  align-items: center
  padding: 8px
  cursor: pointer;
}

.chatbox-loading-mask {
  position: absolute
  top: 0
  left: 0
  display: flex
  justify-content: center
  align-items: center
  background-color #fff
}

.border-radius-5 {
  border-radius: 5px
}
</style>
